import getScrollInfo from '../get-scroll-info';

const preventBodyScroll = (selector) => {
  let lastY;

  const onScroll = (e) => {
    const { clientY } = e.touches[0];
    const scrollDirection = clientY > lastY ? 'up' : 'down';

    lastY = clientY;

    let element = e.target;

    while (element && !element.matches(selector)) {
      const scroll = getScrollInfo(element);

      if (scroll.isVisible) {
        if (scroll.position.bottom) {
          element.scrollTop -= 5;
        }

        if (scroll.position.top) {
          element.scrollTop += 5;
        }

        if (
          (scrollDirection === 'down' && !scroll.position.bottom) ||
          (scrollDirection === 'up' && !scroll.position.top)
        ) {
          return;
        }

        break;
      }

      element = element.parentElement;
    }
  };

  return onScroll;
};

export default preventBodyScroll;
